import React, { useEffect, useState } from 'react'
import { FaImages } from 'react-icons/fa'
import GalleryTab from './GalleryTab.jsx'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

// Gallery is currently enabled only for the Merizhelle–Marvic invitation.
// Add future invitation IDs here only after their gallery feature is configured.
const GALLERY_ENABLED_INVITATIONS = new Set([
  'merizhelle-kate-c-escondo-marvic-m-aranza-wedding',
])

export default function GalleryFeature({ accessCode, purpose, onUnavailableClose }) {
  const [availability, setAvailability] = useState('checking')

  useEffect(() => {
    const code = String(accessCode || '').trim()
    if (!code) {
      setAvailability('unavailable')
      return undefined
    }

    let cancelled = false
    setAvailability('checking')

    ;(async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/rsvp/public-summary?code=${encodeURIComponent(code)}`
        )
        const payload = await response.json().catch(() => ({}))
        if (!response.ok) {
          if (!cancelled) setAvailability('unavailable')
          return
        }

        const invitationId = String(payload.invitationId || payload.id || '')
          .trim()
          .toLowerCase()

        if (!cancelled) {
          setAvailability(
            GALLERY_ENABLED_INVITATIONS.has(invitationId)
              ? 'available'
              : 'unavailable'
          )
        }
      } catch {
        if (!cancelled) setAvailability('unavailable')
      }
    })()

    return () => {
      cancelled = true
    }
  }, [accessCode])

  if (availability === 'checking') {
    return (
      <div className="printable-loading-panel gallery-feature-loading-panel" role="status">
        <div className="printable-icon gallery-feature-icon" aria-hidden="true">
          <FaImages />
        </div>
        <p className="printable-status">Checking Gallery availability...</p>
      </div>
    )
  }

  if (availability === 'unavailable') {
    return <NoGalleryState onClose={onUnavailableClose} purpose={purpose} />
  }

  return <GalleryTab accessCode={accessCode} />
}

function NoGalleryState({ onClose, purpose }) {
  return (
    <div className="printable-unavailable-shell gallery-unavailable-shell">
      <div
        className="printable-unavailable-card gallery-unavailable-card"
        role="status"
        aria-labelledby="gallery-unavailable-title"
      >
        <div className="printable-unavailable-icon gallery-feature-icon" aria-hidden="true">
          <FaImages />
        </div>
        <h2 id="gallery-unavailable-title">Gallery Not Available</h2>
        <p>
          An Event Gallery is not yet set up for this invitation.
          Please contact our customer service to request or enable this feature.
        </p>
        {purpose && <div className="dashboard-feature-purpose">{purpose}</div>}
        <a
          className="printable-unavailable-primary"
          href="mailto:logicatechnology.dev@gmail.com?subject=Event Gallery Feature Request"
        >
          Contact Customer Service
        </a>
        {onClose && (
          <button className="printable-unavailable-secondary" onClick={onClose}>
            Back to Seat Checker
          </button>
        )}
      </div>
    </div>
  )
}
